import { useEffect, useState } from "react";
import "./VillageDetailPage.css";
import ServiceCard from "../../components/card/ServiceCard";
import AgricultureCard from "../../components/card/AgricultureCard";
import { Link, useParams } from "react-router-dom";
import search_g from "../../assets/images/search_g.gif";
import logo from "../../assets/images/gaon_logo.svg";
import banner from "../../assets/images/banner.jpg";
import GaonNear from "../../components/card/GaonNear";
import ContactCard from "../../components/card/ContactCard";
import { Loader } from "../../components/loader";
import {
  fetchGaonDetails,
  getGaonServices,
  getProductsByGaonId,
} from "../../action/gaonApi";
const placeTypeTitles = [
  { type: 0, value: "Nearest Police Station" },
  { type: 1, value: "Nearest Hospital" },
  { type: 2, value: "Nearest Schools and Colleges" },
  { type: 3, value: "Government Office" },
  { type: 4, value: "Railway Station" },
  { type: 5, value: "Bus Station" },
];

export default function ShowGaon() {
  const { id } = useParams();

  // console.log("village", village);

  const [activeTab, setActiveTab] = useState(1);
  const [loading, setIsLoading] = useState(true);
  const [gaonDetails, setGaonDetails] = useState({});
  const isDataLoaded = gaonDetails && Object.keys(gaonDetails).length > 0;
  const [productList, setProductList] = useState([]);
  const [gaonServices, setGaonServices] = useState([]);

  const showgaonDetails = async () => {
    setIsLoading(true);
    try {
      const response = await fetchGaonDetails(id);
      if (response.status) {
        setGaonDetails(response?.data);
      }
    } catch (error) {
      console.error("Failed to fetch gaon details", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getProductList = async () => {
    const res = await getProductsByGaonId(id);
    if (res.status) {
      setProductList(res.data?.list);
    }
  };

  const fetchGaonServices = async () => {
    const res = await getGaonServices(id);
    if (res.status) {
      setGaonServices(res.data?.list);
    }
  };

  useEffect(() => {
    showgaonDetails();
    getProductList();
    fetchGaonServices();
  }, [id]);

  return (
    <>
      {/* <VillageStructuredData village={village} /> */}
      {!isDataLoaded ? (
        <Loader />
      ) : (
        <div className="village-page">
        {/* Hero Section */}
        <section className="gaon_hero">
          <div className="max_container">
            {gaonDetails?.extras?.showNotice ? (
              <div className="notice-bar">
                Notice : {gaonDetails?.extras?.notice}
              </div>
            ) : (
              ""
            )}

            <div className="gaon_title_head">
              <div className="gaon_text">
                <h1 className="gaon_ttl">{gaonDetails.name}</h1>
                <p className="gaon_desc">
                  Village in {gaonDetails?.stateDetails?.name},{" "}
                  {gaonDetails?.pincode}
                </p>
                <div className="gaon_desc1">
                  Slug:{" "}
                  <a
                    className="llink"
                    target="_blank"
                    href={`${
                      process.env.REACT_APP_GAON_PAGE_URL + gaonDetails?.slug
                    }`}
                  >
                    {gaonDetails?.slug}
                  </a>
                </div>
              </div>
              <div className="">
                <Link to={`/gaon/edit/${id}`}>
                  <button type="button" isLight className="gaon_edit_btn">
                    Edit
                  </button>
                </Link>
              </div>
            </div>

            <div className="gaon_hero_content">
              <div className="row">
                <div className="col-lg-12">
                  <div className="gaon_hero_banner">
                    <img src={banner} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="gaon_details">
          <div className="max_container">
            <div className="gaon_detail_content">
              <div className="custom-tabs">
                <div className="tab-buttons">
                  <button
                    className={`tab-button ${activeTab === 1 ? "active" : ""}`}
                    onClick={() => setActiveTab(1)}
                  >
                    Overview
                  </button>
                  <button
                    className={`tab-button ${activeTab === 2 ? "active" : ""}`}
                    onClick={() => setActiveTab(2)}
                  >
                    Browse
                  </button>
                  {/*   <button
                    className={`tab-button ${activeTab === 3 ? "active" : ""}`}
                    onClick={() => setActiveTab(3)}
                  >
                    Gaon Feed
                  </button> */}
                  <button
                    className={`tab-button ${activeTab === 4 ? "active" : ""}`}
                    onClick={() => setActiveTab(4)}
                  >
                    Photos
                  </button>
                </div>
                <div className="tab-content">
                  {activeTab === 1 && (
                    <div className="tab-panel">
                      <div className="gaon_address_box">
                        <div className="gaon_address">
                          <div className="gaon_dtl_ttl">Taluka</div>
                          <div className="gaon_dtl_txt">
                            {gaonDetails?.blockDetails?.name}
                          </div>
                        </div>
                        <div className="gaon_address">
                          <div className="gaon_dtl_ttl">District</div>
                          <div className="gaon_dtl_txt">
                            {gaonDetails?.districtDetails?.name}
                          </div>
                        </div>
                        <div className="gaon_address">
                          <div className="gaon_dtl_ttl">State</div>
                          <div className="gaon_dtl_txt">
                            {gaonDetails?.stateDetails?.name}
                          </div>
                        </div>
                        <div className="gaon_address">
                          <div className="gaon_dtl_ttl">Population</div>
                          <div className="gaon_dtl_txt">
                            {gaonDetails?.demography?.population}
                          </div>
                        </div>
                        <div className="gaon_address">
                          <div className="gaon_dtl_ttl">Pincode</div>
                          <div className="gaon_dtl_txt">
                            {gaonDetails?.pincode}
                          </div>
                        </div>
                        <div className="gaon_address">
                          <div className="gaon_dtl_ttl">STD Code</div>
                          <div className="gaon_dtl_txt">
                            {gaonDetails?.stdCode}
                          </div>
                        </div>
                        <div className="gaon_address">
                          <div className="gaon_dtl_ttl">Census ID</div>
                          <div className="gaon_dtl_txt">
                            {gaonDetails?.censusId}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-7">
                          <div className="ddtl_box">
                            <div className="ddtl_title">
                              About {gaonDetails.name}{" "}
                            </div>
                            <div className="gaon_dtl_ttl">
                              {gaonDetails.info}
                            </div>
                          </div>
                          <div className="ddtl_box">
                            <div className="ddtl_title">
                              Gram Panchayat Info
                            </div>
                            <div className="gaon_address_box">
                              <div className="gaon_address">
                                <div className="gaon_dtl_ttl">
                                  Contituent Assembaly
                                </div>
                                <div className="gaon_dtl_txt">
                                  {
                                    gaonDetails?.gramPanchayatInfo
                                      ?.constituentAssembly
                                  }
                                </div>
                              </div>
                              <div className="gaon_address">
                                <div className="gaon_dtl_ttl">Assembly MLA</div>
                                <div className="gaon_dtl_txt">
                                  {gaonDetails?.gramPanchayatInfo?.assemblyMLA}
                                </div>
                              </div>
                              <div className="gaon_address">
                                <div className="gaon_dtl_ttl">
                                  Lok Sabha Contituency
                                </div>
                                <div className="gaon_dtl_txt">
                                  {
                                    gaonDetails?.gramPanchayatInfo
                                      ?.lokSabhaConstituency
                                  }
                                </div>
                              </div>
                              <div className="gaon_address">
                                <div className="gaon_dtl_ttl">
                                  Parliyament MP
                                </div>
                                <div className="gaon_dtl_txt">
                                  {gaonDetails?.gramPanchayatInfo?.parliamentMP}
                                </div>
                              </div>
                              <div className="gaon_address">
                                <div className="gaon_dtl_ttl">Sarpanch</div>
                                <div className="gaon_dtl_txt">
                                  {gaonDetails?.gramPanchayatInfo?.sarpanch}
                                </div>
                              </div>
                              <div className="gaon_address">
                                <div className="gaon_dtl_ttl">Secretary</div>
                                <div className="gaon_dtl_txt">
                                  {gaonDetails?.gramPanchayatInfo?.secretary}
                                </div>
                              </div>
                            </div>{" "}
                            <div className="info_table-box">
                              <table className="info_table" border={1}>
                                <thead>
                                  <tr>
                                    <th>Year</th>
                                    <th>Chairman</th>
                                    <th>Secretary</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {gaonDetails?.gramPanchayatInfo
                                    ?.previousData &&
                                  gaonDetails?.gramPanchayatInfo?.previousData
                                    .length > 0 ? (
                                    gaonDetails?.gramPanchayatInfo?.previousData?.map(
                                      (data, i) => {
                                        return (
                                          <tr key={i}>
                                            <td>{data?.year}</td>
                                            <td>{data?.sarpanch}</td>
                                            <td>{data?.secretary}</td>
                                          </tr>
                                        );
                                      }
                                    )
                                  ) : (
                                    <tr>
                                      <td colSpan="5" className="text_center">
                                        No data found
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-5">
                          <div className="emergency_contacts">
                            <div className="emergency_ttl">
                              Emergency Contact
                            </div>
                            <ContactCard
                              data={gaonDetails?.emergencyContacts}
                              icons={gaonDetails?.emergencyContactIcons}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {activeTab === 2 && (
                    <div className="tab-panel">
                      <div className="browse_service">
                        {gaonServices?.map((s) => {
                          return <ServiceCard key={s._id} data={s} />;
                        })}
                      </div>
                    </div>
                  )}
                  {activeTab === 4 && (
                    <div className="tab-panel">
                      <div class="address_option">
                        <div className="gaonImages">
                          <div className="row">
                            {gaonDetails?.pic?.length > 0 ? (
                              gaonDetails?.pic.map((value, index) => (
                                <div
                                  className="col-lg-3 col-md-4 col-sm-6 col-12"
                                  key={index}
                                >
                                  <div className="image_card_img">
                                    <img
                                      src={`${process.env.REACT_APP_S3_URL}/${value.url}`}
                                      alt="Preview"
                                    />
                                  </div>
                                </div>
                              ))
                            ) : (
                              <p>No images available</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {activeTab === 1 && (
                  <section className="agriculture">
                    <div className="ddtl_box">
                      <div className="ddtl_title">Agriculture Information</div>
                      <div className="gaon_dtl_ttl">
                        {gaonDetails?.aggriculturalInfo?.desc}
                        <div className="agri_cards">
                          {productList && productList.length > 0 ? (
                            productList?.map((p) => (
                              <AgricultureCard product_data={p} />
                            ))
                          ) : (
                            <p>No products available</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </section>
                )}
              </div>
            </div>
          </div>
        </section>
        {activeTab === 1 && gaonDetails.nearPlacesDetails?.length > 0
          ? gaonDetails?.nearPlacesDetails?.map((nearPlace, index) => {
              const matchedTitle = placeTypeTitles.find(
                (p) => Number(p.type) === Number(nearPlace.type)
              );

              return (
                <GaonNear
                  key={index}
                  title={`${matchedTitle?.value} in ${gaonDetails?.name}`}
                  data={nearPlace}
                  sliderId={`slider-${index}`}
                />
              );
            })
          : ""}
        <section>
          <div className="max_container"></div>
        </section>
      </div>
      )}
    </>
  );
}
